module.exports = __webpack_public_path__ + "img/free.e2dd220e.png";